module.exports = __webpack_public_path__ + "static/media/project-image-10.abc3e42c.jpg";